/* 
 	* 设备信息详情 
 	* 描述：包括查询（表单）、表格和分页
 	* 创建时间：2017-03-22 
 	* 创建人：Shujuan Sun 
 	* 修改时间：2017-3-31
 	* 修改人：baixx 
*/<template>
<div class="wrapper-content fadeInRight animated tabBox" id="device-detail">
	<div class="ibox-content" v-loading="loadingstatus!=4" element-loading-text="加载中">
		<div class="form-horizontal pt10px">
		    <div class="form-group">
				<label class="col-sm-1 control-label ">车辆ID</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" readonly v-model="queryparam.displayVehicleid">
				</div>
				<label class="col-sm-1 control-label ">服务卡号</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" readonly v-model="vehicleInfo.vehicleAccount">
				</div>
				<label class="col-sm-1 control-label ">当前里程</label>
				<div class="col-sm-2">
					<div class="input-group">
	                    <input type="text" class="form-control" readonly v-model="vehicleInfo.totalMileage"> 
						<span class="input-group-btn" v-if="levv==1" key="user-didi"> 
	                    	<button v-if="permissionD.indexOf('fileCarList_deviceInfoCalibrate') == -1" type="button" class="btn btn-primary" @click="openSubPage">校准</button> 
	                    </span>
	                    <span class="input-group-btn" v-else key="user-rb"> 
	                    	<button v-if="permission.indexOf('carFileList_deviceInfoCalibrate') == -1" type="button" class="btn btn-primary" @click="openSubPage">校准</button> 
	                    </span>
	                </div>
				</div>	
				<label class="col-sm-1 control-label ">当前所在城市</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" readonly v-model="vehicleInfo.posCity">
				</div>	
			</div>
			<div class="gray-bg pb5px">
				<!--中间tab开始-->
				<ul class="col-sm-12 pl0px pt0px tip_page_tabs" style="overflow:hidden;">
					<li v-for="(subTab,index) in subTabList" @click="goSubTab(index,subTab.route)" class="t_center" :class="{active:currentIndex === index}">
						<a v-text="subTab.name"></a>
					</li>
				</ul>
			
				<!--中间tab结束-->
				<!--各subTab对应组件渲染区域-->
				<keep-alive>
					<component v-bind:is="currentView" style="clear:both;">
					  	<!-- 组件在 vm.currentview 变化时改变！ -->
					</component>
				</keep-alive>
			</div>
		</div>	
	</div>
	<!--   弹出框子组件        -->
	<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModal('modalMsg')">
		{{messageStr}}
		<div slot="footer">
	        <button @click="closeModal('modalMsg')" class="btn btn-primary">确定</button>
	    </div>
	</tab-modal>
	
	<!--里程校准输入框-->
	<sub-page :show="toShow" :bigTitleMsg="bigTitle" :scroll='scrollTop' :width='30' v-on:cancel="closeSubPage">
		<div slot="bodycontent">
			<div class="m20px">
				<div class="form-group">
				    <label>请输入当前车辆实际里程</label>
				    <input-number :min="1" :max="1000000" :controls="false" :inputWidth="200" v-model="mileageNum"></input-number>
				</div>
				<div class="form-group text-center" v-if="levv==1" key="user-didi">
					<button v-if="permissionD.indexOf('fileCarList_deviceInfoCalibrateSure') == -1" class="btn btn-primary" @click="correctMileage">确定</button>
				</div>
				<div class="form-group text-center" v-else key="user-rb">
					<button v-if="permission.indexOf('carFileList_deviceInfoCalibrateSure') == -1" class="btn btn-primary" @click="correctMileage">确定</button>
				</div>
			</div>
		</div>
	</sub-page>
		
</div>
</template>
<script>
	import DetailInfo from "components/pages/devicedetail/DetailInfo"
	import HistoryPosition from "components/pages/devicedetail/HistoryPosition"
	import HistoryInstruction from "components/pages/devicedetail/HistoryInstruction"
	import InputNumber from 'components/common/InputNumber'
	import SubPage from 'components/common/SubPage'
	import { OPERATE_EXCEPTION } from 'static/message'
    import TabModal from 'components/common/TabModal'
    import classlist from 'util/classlist'
    
	export default{
		name:'PageDeviceDetail',
		components:{
			DetailInfo,
			HistoryPosition,
			HistoryInstruction,
			InputNumber,
			SubPage,
			TabModal
		},
		data(){
			return {
				permission:this.$store.state.permission.permission["carFileList"]?this.$store.state.permission.permission["carFileList"]:[],
				permissionD:this.$store.state.permission.permission["fileCarList"]?this.$store.state.permission.permission["fileCarList"]:[],
				loadingstatus:0,
				//查询参数
				queryparam:{
					displayDeviceid:'',
					deviceid: '',
					vehicleid:''
				},
				//车辆信息
				vehicleInfo: {	
					vehicleId:'',
					vehicleAccount: "",		// 服务卡号
					totalMileage: "",		// 里程
					posCity: ""				// 当前所在城市
				},
				//设备信息
				deviceInfo: {	
					deviceid:'',
					deviceNum:'',
					obdFlag:''
				},
				subTabList: [{
						name: "设备详情",
						route: "detailInfo"
					}, {
						name: "历史定位一览",
						route: "historyPosition"
					}, {
						name: "历史指令一览",
						route: "historyInstruction"
					}],
				currentIndex: 0,
				currentView: "detailInfo",
				messageStr:'',
				scrollTop: "0px",
				toShow: false, 					//里程弹框是否显示
				bigTitle: '里程校准', 			//里程弹框标题
				mileageNum:1,					//校准里程数
			}
		},
		computed:{
			levv(){
				return this.$store.state.user.levv
			}
		},
		// 组件初始化
		beforeMount(){
			this.getVehicleInfo();
		},
		// 接收设备ID
		created(){
			this.queryparam.deviceid = this.$route.query.deviceid;
			this.queryparam.displayVehicleid = 'VE' + this.$route.query.vehicleid
			this.queryparam.vehicleid = this.$route.query.vehicleid;
			this.deviceInfo.deviceid = this.$route.query.deviceid;
			this.deviceInfo.deviceNum = this.$route.query.devicenum;
			this.deviceInfo.obdFlag = this.$route.query.devicetype;
		},
		methods:{
			goSubTab(index, route) {
				this.currentView = route;
				this.currentIndex = index;
			},
			// 获取车辆基本详情：服务卡号，里程，城市
			getVehicleInfo(){
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/'+ this.queryparam.vehicleid)
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;
						this.vehicleInfo.vehicleAccount = res.data.data.vehicleAccount;
						this.vehicleInfo.totalMileage = res.data.data.totalMileage;
						this.vehicleInfo.posCity = res.data.data.posCity;
						this.vehicleInfo.vehicleId = res.data.data.vehicleId;
						this.mileageNum = this.vehicleInfo.totalMileage;
					}else{
						this.openModal(res.body.message);
					}
					this.loadingstatus += 1;
				}, res => {
						this.openModal(res.body.message);
						this.loadingstatus += 1;
				}).catch( res => {
					this.openModal(OPERATE_EXCEPTION);
					this.loadingstatus += 1;
				})
			},
			// 里程校准
			correctMileage(){
				const param = {
					vehicleId:this.queryparam.vehicleid,
					mileage:this.mileageNum
				}
				this.closeSubPage();
				this.$http.put(process.env.API_ROOT + '/vehicle/vehicles/mileage', param)
				.then( res => {
					if(res.body.success){
						this.mileageNum = res.body.data;
						this.vehicleInfo.totalMileage = res.body.data;
					}else{
						this.openModal(res.body.message);
					}
				}, res => {
						this.openModal(res.body.message);
				}).catch( res => {
					this.openModal(OPERATE_EXCEPTION);
				})
			},
			// 打开里程校准弹框
			openSubPage(){
				this.toShow = true;
				classlist.toggleScroll('close','#device-detail',this);
			},
			// 关闭里程校准弹框
			closeSubPage() { 
				this.toShow = false;
				classlist.toggleScroll('open','#device-detail',this);
			},
			// 消息弹出框相关
			openModalMaster(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#device-detail',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#device-detail',this);
        	},
        	openModal(message){
        		this.messageStr = message;
        		this.openModalMaster("modalMsg")
        	}
		}
	}
</script>

<style scoped>
	ul li {
		float: left;
		padding: 5px 10px;
		list-style: none;
	}
	
	ul {
		border: 1px solid #ccc;
	}
	
	li {
		border-right: 1px solid #ccc;
	}
	
	li.active {
		background-color: #000;
	}
</style>


// WEBPACK FOOTER //
// PageDeviceDetail.vue?200a9494